import {
	Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges,
	SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewChild,
	ViewChildren, QueryList, ElementRef, Inject
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { IpAddress, DeviceFilter } from 'DiscoveryEngine.TS/Core';
import { ViewerDeviceFilterDto } from 'UvExplorerServer.Dtos.TS/Viewer';
import { DisplayDeviceListDto, DisplayDeviceListEntryDto } from 'UvExplorerServer.Dtos.TS/Session';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { HashSet, Iterable } from 'DiscoveryEngine.TS/Utils';
import { DeviceFilterService } from 'netview';
import { NavLocation, NavigationService, NetFacadeService } from 'netview';
import { DiscResultsService } from 'discovery';
import { IdentityService } from 'identity';
import { MessageService } from 'base';
import { MonitorService } from 'monitor';
//import { Table } from 'primeng/table';
import { UvTable } from 'widget';
import { Dialog } from 'primeng/dialog';
import { TabView, TabViewChangeEvent } from 'primeng/tabview';


export class MonitorDeviceSelectorEntry {
	public dataKey: string;
	public name: string;
	public ipAddress: string;
	public description: string;

	public ipAddressTag: IpAddress;
	public get hasIpAddressTag(): boolean {
		return !!this.ipAddressTag;
	}

	public deviceTag: DisplayDeviceListEntryDto;
	public get hasDeviceTag(): boolean {
		return !!this.deviceTag;
	}

	constructor() {
		this.dataKey = "";

		this.name = "";
		this.ipAddress = "";
		this.description = "";

		this.ipAddressTag = null;

		this.deviceTag = null;
	}
}

export class MonitorDeviceSelectorResult {
	public devices: DisplayDeviceListEntryDto[];

	constructor() {
		this.devices = [];
	}
}


@Component({
	selector: 'monitor-device-selector',
	templateUrl: './monitor-device-selector.component.html',
	styleUrls: ['./monitor-device-selector.component.scss'],
	//changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonitorDeviceSelectorComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	public header: string;

	@Input()
	public visible: boolean;

	@Input()
	public defaultFilter: string;

	@Input()
	public requireSnmp: boolean;

	@Input()
	public requireWmi: boolean;

	@Input()
	public requireVim: boolean;

	@Input()
	public requireSsh: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<MonitorDeviceSelectorResult>

	@Output()
	public onCancel: EventEmitter<any>;

	@ViewChild('dialog')
	public dialog: Dialog;

	@ViewChild('tabview')
	public tabview: TabView;

	@ViewChild('table')
	// public table: Table;
	public table: UvTable;

	@ViewChildren('filter')
	public filters: QueryList<ElementRef<HTMLInputElement>>;

	@ViewChild('montable')
	// public montable: Table;
	public montable: UvTable;

	@ViewChildren('monfilter')
	public monfilters: QueryList<ElementRef<HTMLInputElement>>;

	private devices: DisplayDeviceListDto;
	private monitorDevices: DisplayDeviceListDto;

	public cols: any[];
	public monitorCols: any[];
	public entries: MonitorDeviceSelectorEntry[];
	public monitorEntries: MonitorDeviceSelectorEntry[];
	public filterEntries: any[];
	public monitoredFirst: number;
	public unmonitoredFirst: number;

	public selectedFilter: ViewerDeviceFilterDto;
	public selectedDevices: any;
	public selectedMonitorDevices: any;

	private networkLoadedSub: Subscription;

	public activeTabIndex: number;

	public devicesLoading: boolean;
	public monDevicesLoading: boolean;

	public readonly VirtualScrollItemSize = 29;
	public get TableRowStyle(): string {
		return `height: ${this.VirtualScrollItemSize}px;`;
	}

	constructor(private changeDetector: ChangeDetectorRef,
		private deviceFilterService: DeviceFilterService,
		private navService: NavigationService,
		private netFacadeService: NetFacadeService,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private messageService: MessageService,
		private monitorService: MonitorService,
		@Inject(DOCUMENT) private document: Document) {

		this.header = "";
		this.visible = false;
		this.defaultFilter = "";
		this.requireSnmp = false;
		this.requireWmi = false;
		this.requireVim = false;
		this.requireSsh = false;
		this.devices = null;
		this.monitorDevices = null;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<MonitorDeviceSelectorResult>();
		this.onCancel = new EventEmitter<any>();
		this.selectedDevices = [];
		this.selectedMonitorDevices = [];
		this.cols = [
			{ field: 'name', header: 'Name', sortable: "custom", sortFunction: (event) => this.doCustomSort(event, this.entries), filterMatchMode: "contains" },
			{ field: 'ipAddress', header: 'IP Address', sortable: "custom", sortFunction: (event) => this.doCustomSort(event, this.entries), filterMatchMode: "contains" },
			{ field: 'description', header: 'Description', sortable: "custom", sortFunction: (event) => this.doCustomSort(event, this.entries), filterMatchMode: "contains" },
		];
		this.monitorCols = [
			{ field: 'name', header: 'Name', sortable: "custom", sortFunction: (event) => this.doCustomSort(event, this.monitorEntries), filterMatchMode: "contains" },
			{ field: 'ipAddress', header: 'IP Address', sortable: "custom", sortFunction: (event) => this.doCustomSort(event, this.monitorEntries), filterMatchMode: "contains" },
			{ field: 'description', header: 'Description', sortable: "custom", sortFunction: (event) => this.doCustomSort(event, this.monitorEntries), filterMatchMode: "contains" },
		];

		this.entries = [];
		this.monitorEntries = [];
		this.filterEntries = [];
		this.monitoredFirst = 0;
		this.unmonitoredFirst = 0;

		this.networkLoadedSub = this.discResultsService.onNetworkLoaded.subscribe(
			() => {
				this.entries = [];
				this.monitorEntries = [];
				this.filterEntries = [];
			},
			(error?) => {
				// ???
			});

		this.activeTabIndex = 0;

		this.devicesLoading = false;
		this.monDevicesLoading = false;
	}

	public doCustomSort(event, entriesToSort: MonitorDeviceSelectorEntry[]): void {
		let comparer = function (a: MonitorDeviceSelectorEntry, b: MonitorDeviceSelectorEntry): number {
			let result = 0;

			switch (event.field) {
				case "ipAddress":
					if (a.ipAddressTag && b.ipAddressTag) {
						result = a.ipAddressTag.CompareTo(b.ipAddressTag);
					}
					else if (a.ipAddressTag) {
						result = 1;
					}
					else if (b.ipAddressTag) {
						result = -1;
					}
					break;
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		entriesToSort.sort(comparer);
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		this.clearSelectedDevices();
		this.clearMonitorSelectedDevices();

		change = changes["visible"];
		if (change) {
			if (this.visible) {
				this.rebuildFilterEntries();
				this.selectDefaultFilter();
				this.rebuildEntries();

				if (this.filters) {
					this.filters.forEach((filter: ElementRef<HTMLInputElement>) => {
						filter.nativeElement.value = "";
					});
				}

				if (this.monfilters) {
					this.monfilters.forEach((monfilter: ElementRef<HTMLInputElement>) => {
						monfilter.nativeElement.value = "";
					});
				}

				if (this.table) {
					this.cols.forEach((col) => {
						this.table.filter("", col.field, col.filterMatchMode)
					});
				}

				if (this.montable) {
					this.monitorCols.forEach((col) => {
						this.montable.filter("", col.field, col.filterMatchMode)
					});
				}

				this.activeTabIndex = 0;

				setTimeout(() => {
					this.dialog.center();
					setTimeout(() => {
						this.dialog.center();
						setTimeout(() => {
							this.dialog.center();
						}, 400);
					}, 200);
				}, 100);
			}
		}
	}

	public ngOnDestroy(): void {
		if (this.networkLoadedSub) {
			this.networkLoadedSub.unsubscribe();
			this.networkLoadedSub = null;
		}
	}
	
	public onActiveIndexChange(value: number): void {
		this.changeDetector.detectChanges();
	}

	public onTabChange(event: TabViewChangeEvent): void {
		switch (event.index) {
			case 0:
				this.monitorEntries = [...this.monitorEntries];
				break;
			case 1:
				this.entries = [...this.entries];
				break;
		}
	}

	public onFilterChange(): void {
		this.clearSelectedDevices();
	}

	private clearSelectedDevices(): void {
		this.selectedDevices = [];
	}

	public onMonitorFilterChange(): void {
		this.clearMonitorSelectedDevices();
	}

	private clearMonitorSelectedDevices(): void {
		this.selectedMonitorDevices = [];
	}

	private resetTables(): void {
		this.changeDetector.markForCheck();

		this.selectedDevices = [];
		this.selectedMonitorDevices = [];

		if (this.table) {
			this.table.reset();
		}
		if (this.montable) {
			this.montable.reset();
		}
	}

	private rebuildEntries(): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let filter: DeviceFilter = this.selectedFilter.DeviceFilter;

		this.entries = [];
		this.monitorEntries = [];

		this.monDevicesLoading = true;
		this.changeDetector.detectChanges();
		this.discResultsService.getFilteredDeviceList(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, "monitor-network", filter, null,
			this.requireSnmp, this.requireWmi, this.requireVim, this.requireSsh, false).subscribe(
				(result: DisplayDeviceListDto) => {

					this.monDevicesLoading = false;
					this.monitorDevices = result;

					this.devicesLoading = true;
					this.changeDetector.detectChanges();
					this.discResultsService.getFilteredDeviceList(sessionGuid, netViewGuid, agentGuid,
						schedDiscGuid, schedDiscRsltGuid, "network", filter, null,
						this.requireSnmp, this.requireWmi, this.requireVim, this.requireSsh, false).subscribe(
							(result: DisplayDeviceListDto) => {

								this.devicesLoading = false;
								this.devices = result;

								// used to filter out monitored devices
								let monitorDeviceGuids = new HashSet<string>();

								if (this.monitorDevices && this.monitorDevices.entries) {
									this.monitorDevices.entries.forEach((device: DisplayDeviceListEntryDto) => {
										if (!!device.ipAddress) {
											monitorDeviceGuids.Add(device.deviceGuid);

											let entry = this.makeEntry(device);
											this.monitorEntries.push(entry);
										}
									}, this);
								}

								if (this.devices && this.devices.entries) {
									this.devices.entries.forEach((device: DisplayDeviceListEntryDto) => {
										if (!!device.ipAddress && !monitorDeviceGuids.Contains(device.deviceGuid)) {
											let entry = this.makeEntry(device);
											this.entries.push(entry);
										}
									}, this);
								}

								this.resetTables();

								// This HACK is a workaround for a bug in PrimeNG's <p-table> component when it is
								// in "virtual scroll" mode. For some reason, when a virtual scroll <p-table> is
								// nested in a <p-tabview> component, sometimes the table does not render correctly.
								// Programmatically selecting the table's tab and calling "detectChanges" seems to help.
								// setTimeout(() => {								
								// 	this.activeTabIndex = 1;
								// 	this.changeDetector.detectChanges();
								// 	setTimeout(() => {
								// 		this.activeTabIndex = 0;
								// 	}, 0);
								// }, 0);

								// This HACK also works
								// setTimeout(() => {
								// 	let monitoredHeader = <HTMLElement>this.document.querySelector(".monitored-header");
								// 	let unmonitoredHeader = <HTMLElement>this.document.querySelector(".unmonitored-header");
								// 	if (!!monitoredHeader && !!unmonitoredHeader) {
								// 		(unmonitoredHeader.firstChild as HTMLElement).click();
								// 		setTimeout(() => {
								// 			this.changeDetector.detectChanges();
								// 			(monitoredHeader.firstChild as HTMLElement).click();
								// 		}, 0);
								// 	}
								// }, 0);
							},
							(error?) => {
								this.devicesLoading = false;
								this.messageService.displayErrorMessage("Could not retrieve filtered device list");
								this.resetTables();
							});
				},
				(error?) => {
					this.monDevicesLoading = false;
					this.messageService.displayErrorMessage("Could not retrieve filtered monitor device list");
					this.resetTables();
				});
	}

	private makeEntry(device: DisplayDeviceListEntryDto): MonitorDeviceSelectorEntry {
		let entry = new MonitorDeviceSelectorEntry();

		entry.dataKey = device.deviceGuid;
		entry.deviceTag = device;
		entry.name = device.name;

		entry.ipAddress = "";
		entry.ipAddressTag = null;
		if (device.ipAddress) {
			entry.ipAddress = device.ipAddress;
			entry.ipAddressTag = IpAddress.Create(device.ipAddress);
		}

		entry.description = device.systemDescription;

		return entry;
	}

	private selectDefaultFilter(): void {
		if (!!this.defaultFilter) {
			for (let i = 0; i < this.filterEntries.length; ++i) {
				if (this.filterEntries[i].name === this.defaultFilter) {
					this.selectedFilter = this.filterEntries[i].filter
					break;
				}
			}
		}
	}

	public onSelectClick(): void {
		window.alert('click');
	}

	private rebuildFilterEntries(): void {

		this.filterEntries = [];

		this.deviceFilterService.getBuiltInDeviceFilters().forEach((vdf: ViewerDeviceFilterDto) => {
			this.filterEntries.push({ index: this.filterEntries.length, name: vdf.DeviceFilter.Name, filter: vdf });
		}, this);

		let navLoc = this.navService.location;
		if (navLoc && navLoc.hasNetViewGuid) {
			let network = this.netFacadeService.findNetwork(navLoc.netViewGuid);
			if (network) {
				network.DeviceFilters.ForEach((vdf: ViewerDeviceFilterDto) => {
					this.filterEntries.push({ index: this.filterEntries.length, name: vdf.DeviceFilter.Name, filter: vdf });
				}, this);
			}
		}

		this.selectedFilter = this.filterEntries[0].filter;
	}

	public onSelectedFilterChange(event): void {
		let index = event.target.value;
		this.selectedFilter = this.filterEntries[index].filter;

		//this.selectedDevices = [];
		//this.selectedMonitorDevices = [];
		this.rebuildEntries();
		this.monitoredFirst = 0;
		this.unmonitoredFirst = 0;
	}

	public isOkEnabled(): boolean {
		return (this.selectedDeviceCount > 0 || this.selectedMonitorDeviceCount > 0);
	}

	public onOkClicked(): void {
		this.getSelectedDevices().subscribe(
			(result: MonitorDeviceSelectorResult) => {
				this.rebuildEntries();
				this.onOk.emit(result);
				this.hide();
			},
			(error) => {
				this.messageService.displayErrorMessage("Could not add devices to monitor network");
				this.hide();
			});
	}

	public onCancelClicked(): void {
		this.onCancel.emit();
		this.hide();
	}

	private getSelectedDevices(): Observable<MonitorDeviceSelectorResult> {

		let newMonDeviceGuids: string[] = [];
		let selectedDevicesResult = new MonitorDeviceSelectorResult();

		if (this.selectedDevices) {
			if (Array.isArray(this.selectedDevices)) {
				this.selectedDevices.forEach((entry: MonitorDeviceSelectorEntry) => {
					selectedDevicesResult.devices.push(entry.deviceTag);
					newMonDeviceGuids.push(entry.dataKey);
				}, this);
			}
			else {
				let entry = <MonitorDeviceSelectorEntry>this.selectedDevices;
				selectedDevicesResult.devices.push(entry.deviceTag);
				newMonDeviceGuids.push(entry.dataKey);
			}
		}
		if (this.selectedMonitorDevices) {
			if (Array.isArray(this.selectedMonitorDevices)) {
				this.selectedMonitorDevices.forEach((entry: MonitorDeviceSelectorEntry) => {
					selectedDevicesResult.devices.push(entry.deviceTag);
				}, this);
			}
			else {
				let entry = <MonitorDeviceSelectorEntry>this.selectedMonitorDevices;
				selectedDevicesResult.devices.push(entry.deviceTag);
			}
		}

		if (newMonDeviceGuids.length > 0) {
			let subject = new Subject<MonitorDeviceSelectorResult>();

			let sessionGuid = this.identityService.sessionGuid;
			let netViewGuid = this.navService.location.netViewGuid;
			let agentGuid = this.navService.location.agentGuid;
			let schedDiscGuid = this.navService.location.schedDiscGuid;
			let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

			this.monitorService.addDevicesToAgentMonitorNetwork(sessionGuid, netViewGuid, agentGuid,
				schedDiscGuid, schedDiscRsltGuid, newMonDeviceGuids).subscribe(
					(result: boolean) => {
						subject.next(selectedDevicesResult);
					},
					(error) => {
						subject.error(error);
					});

			return subject.asObservable();
		}
		else {
			return new Observable<MonitorDeviceSelectorResult>(observer => {
				observer.next(selectedDevicesResult);
			});
		}
	}

	public get totalDeviceCount(): number {
		if (this.entries)
			return this.entries.length;
		else
			return 0;
	}

	public get selectedDeviceCount(): number {
		if (this.selectedDevices) {
			if (Array.isArray(this.selectedDevices)) {
				return this.selectedDevices.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}

	public get totalMonitorDeviceCount(): number {
		if (this.monitorEntries)
			return this.monitorEntries.length;
		else
			return 0;
	}

	public get selectedMonitorDeviceCount(): number {
		if (this.selectedMonitorDevices) {
			if (Array.isArray(this.selectedMonitorDevices)) {
				return this.selectedMonitorDevices.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}

	public get overallTotalDeviceCount(): number {
		return this.totalDeviceCount + this.totalMonitorDeviceCount;
	}

	public get overallSelectedDeviceCount(): number {
		return this.selectedDeviceCount + this.selectedMonitorDeviceCount;
	}
}
